import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SearchBox from "@/components/feature/SearchBox";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import NewsSection from "@/pages/home/components/NewsSection";
import FeatureSection from "@/pages/home/components/FeatureSection";
import SiteIntro from "@/pages/home/components/SiteIntro";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function Home() {
  const location = useLocation();

  useDocumentTitle(
    "亲吻姐姐 - 热门影视剧资讯与剧情解析",
    "亲吻姐姐提供最新影视剧资讯、剧情介绍和角色分析，覆盖多种类型影视作品，帮助用户深入了解剧情和角色发展。"
  );

  useEffect(() => {
    if (location.hash === "#features") {
      window.setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, [location]);

  return (
    <SiteLayout>
      <section className="border-b border-background-200 bg-background-50">
        <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-film-line"></i>
              热门影视剧资讯 · 剧情解析 · 角色分析
            </span>
            <h1 className="mt-5 font-heading text-3xl font-extrabold leading-tight text-foreground-950 md:text-5xl">
              看懂一部剧，
              <br className="hidden sm:block" />
              从读懂它的剧情与角色开始。
            </h1>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              亲吻姐姐覆盖电影、电视剧、网络剧等多种类型，提供最新影视资讯、分区分段的剧情介绍与角色动机剖析。
              输入作品名称或角色名，马上开始你的深度观影之旅。
            </p>
            <div className="mt-7 max-w-xl">
              <SearchBox size="lg" placeholder="搜索影视作品名称或角色名，例如：锦岁长安、沈砚" />
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <span className="text-foreground-600">热门搜索：</span>
              {[
                { label: "锦岁长安", q: "锦岁长安" },
                { label: "逆流黎明", q: "逆流黎明" },
                { label: "沈砚", q: "沈砚" },
                { label: "悬案笔记", q: "悬案笔记" }
              ].map((tag) => (
                <Link
                  key={tag.label}
                  to={`/search?q=${encodeURIComponent(tag.q)}`}
                  className="cursor-pointer rounded-full bg-background-200 px-3 py-1.5 text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
                >
                  {tag.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <HeroCarousel />
      <CategoryEntry />
      <NewsSection />
      <FeatureSection />
      <SiteIntro />
    </SiteLayout>
  );
}